export default __webpack_public_path__ + "static/media/mexico.f605ec8f.svg";